var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eval-status",class:{ 'eval-none': _vm.evalCode === 0 },style:(_vm.statusStyle)},[_vm._v(" "+_vm._s(_vm.evalNameList[_vm.evalCode])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }